export const RefreshTokenPattern =
  'CognitoIdentityServiceProvider.*.refreshToken';
export const AccessTokenPattern =
  'CognitoIdentityServiceProvider.*.accessToken';
export const IdTokenPattern = 'CognitoIdentityServiceProvider.*.idToken';
export const UserDataPattern = 'CognitoIdentityServiceProvider.*.userData';
